/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-08-26
 */
export var modelTypeSymbol = Symbol('mmlpx-model-type');
export var modelNameSymbol = Symbol('mmlpx-model-name');
export var storeSymbol = Symbol('Store');
export var viewModelSymbol = Symbol('ViewModel');
export var postConstructSymbol = Symbol('postConstruct');
export function getModelName(model) {
  return model[modelNameSymbol];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mmlpx/esm/core/dependency-inject/meta.js
// module id = null
// module chunks = 